import script from "./dependents-incorporation-no-deliverable-form-success.vue?vue&type=script&setup=true&lang=js"
export * from "./dependents-incorporation-no-deliverable-form-success.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__